import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { motion } from "framer-motion"

const StyledToggleButton = styled(motion.button)`
  position: relative;
  width: 3.5rem;
  height: 1.75rem;
  background: ${({ theme, $darkMode }) =>
    $darkMode ? theme.colors.primary : theme.colors.tertiary};
  border: none;
  border-radius: 2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0.25rem;
  transition: background 0.3s ease;

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  &:hover {
    opacity: 0.8;
  }
`

const StyledToggleCircle = styled(motion.div)`
  width: 1.25rem;
  height: 1.25rem;
  background: ${({ theme }) => theme.colors.background};
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`

const ThemeToggle = ({ darkMode, toggleDarkMode }) => {
  return (
    <StyledToggleButton
      onClick={toggleDarkMode}
      aria-label={`Switch to ${darkMode ? "light" : "dark"} mode`}
      $darkMode={darkMode}
      whileTap={{ scale: 0.95 }}
    >
      <StyledToggleCircle
        animate={{
          x: darkMode ? 28 : 0,
        }}
        transition={{
          type: "spring",
          stiffness: 700,
          damping: 30,
        }}
      />
    </StyledToggleButton>
  )
}

ThemeToggle.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  toggleDarkMode: PropTypes.func.isRequired,
}

export default ThemeToggle
